var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBro(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 225,
    viewBox: "0 0 240 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.1612 38.9844H31.7725C30.386 38.9844 29.0564 39.5351 28.076 40.5155C27.0957 41.4959 26.5449 42.8255 26.5449 44.2119V60.4174C26.5449 61.8038 27.0957 63.1335 28.076 64.1138C29.0564 65.0942 30.386 65.6449 31.7725 65.6449H74.8999L80.3888 72.9635V44.2119C80.3888 42.8255 79.838 41.4959 78.8577 40.5155C77.8773 39.5351 76.5477 38.9844 75.1612 38.9844Z",
    fill: "#263238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 56.8308H34.4316V46.8984H35.9999V51.1484H37.7668V46.8984H39.3351V56.8308H37.7668V52.5808H35.9999V56.8308Z",
    fill: "#FF725E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4912 46.9141H42.0595V56.8464H40.4912V46.9141Z",
    fill: "#FF725E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9216 46.9141H49.7362V48.3307H48.1052V56.8308H46.5369V48.3307H44.9111L44.9216 46.9141Z",
    fill: "#FF725E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9677 56.8308H50.3994V46.8984H51.9677V51.1484H53.7294V46.8984H55.2976V56.8308H53.7294V52.5808H51.9572L51.9677 56.8308Z",
    fill: "#FF725E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0163 51.0909H60.1544V52.5076H58.0163V55.4141H60.7085V56.8308H56.4585V46.8984H60.7085V48.3151H58.0163V51.0909Z",
    fill: "#FF725E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9271 56.8256C64.7993 56.4331 64.7513 56.019 64.786 55.6076V54.0393C64.786 53.1193 64.4775 52.7795 63.7404 52.7795H63.2177V56.8152H61.6494V46.8828H64.0018C65.6171 46.8828 66.3124 47.6356 66.3124 49.162V49.9409C66.3124 50.9603 65.9831 51.6294 65.2669 51.9535C66.0458 52.2829 66.3124 53.0304 66.3124 54.0446V55.5762C66.2841 55.9847 66.3429 56.3945 66.4849 56.7786L64.9271 56.8256ZM63.2281 48.3256V51.3733H63.8398C64.42 51.3733 64.7755 51.1171 64.7755 50.3278V49.345C64.7755 48.6393 64.535 48.2995 63.9809 48.2995L63.2281 48.3256Z",
    fill: "#FF725E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9317 51.0909H71.0698V52.5076H68.9317V55.4141H71.6187V56.8308H67.3687V46.8984H71.6187V48.3151H68.9317V51.0909Z",
    fill: "#FF725E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.7792 54.6352L72.5806 51.0491V46.9141H74.1488V51.0491L73.9502 54.6352H72.7792ZM74.107 55.3304V56.8308H72.6067V55.3304H74.107Z",
    fill: "#FF725E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.349 39.5009C148.349 39.5009 146.415 38.8161 145.976 40.5464C145.537 42.2767 148.098 42.9197 148.412 42.9197C148.725 42.9197 149.222 42.4858 148.908 41.4873C148.595 40.4889 148.349 39.5009 148.349 39.5009Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M159.334 35.2578C159.334 35.2578 159.146 37.7566 159.146 38.7551C159.146 39.7535 160.192 40.1299 160.714 40.1299C161.237 40.1299 161.467 41.3166 161.153 42.5659C160.84 43.8153 159.779 44.5629 157.217 44.5629C154.656 44.5629 153.098 43.4389 153.035 42.6287C152.972 41.8184 153.594 38.3159 154.661 37.4011C155.727 36.4863 159.334 35.2578 159.334 35.2578Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M149.985 42.9406V43.9077C149.985 44.0599 150.029 44.2088 150.112 44.3367C150.194 44.4645 150.312 44.5661 150.45 44.6291C150.899 44.8189 151.376 44.9337 151.862 44.9689C152.84 44.9691 153.808 44.755 154.695 44.3416C154.818 44.2892 154.922 44.2018 154.996 44.0902C155.069 43.9786 155.108 43.8479 155.108 43.7143V42.7054C155.107 42.6439 155.091 42.5836 155.061 42.5298C155.031 42.4759 154.988 42.4303 154.937 42.3967C154.885 42.3632 154.826 42.3428 154.765 42.3374C154.703 42.332 154.642 42.3417 154.585 42.3656L154.381 42.4701C154.381 42.4701 151.297 42.8622 149.985 42.9406Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M148.607 34.7554C148.265 36.1287 148.034 37.5272 147.917 38.9375C147.729 41.2481 147.917 43.3705 148.852 43.4332C149.494 43.4343 150.123 43.253 150.666 42.9104C150.666 42.9104 152.852 43.1614 153.599 42.7902L154.352 42.4138L154.911 38.7545C154.911 38.7545 154.974 33.0722 153.913 32.6958C152.852 32.3194 148.607 34.7554 148.607 34.7554Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.292 37.3203L149.796 38.6324C149.796 38.6324 148.792 38.8834 148.918 39.38C149.043 39.8766 149.707 39.8034 149.707 39.8034",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M151.884 37.888C151.785 38.1598 151.581 38.3376 151.44 38.2853C151.299 38.233 151.257 37.9664 151.362 37.6894C151.466 37.4123 151.665 37.2346 151.811 37.2921C151.958 37.3496 151.999 37.6318 151.884 37.888Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M149.547 37.2533C149.442 37.5304 149.244 37.7081 149.097 37.6558C148.951 37.6036 148.92 37.3317 149.019 37.0599C149.118 36.7881 149.322 36.6051 149.469 36.6574C149.615 36.7096 149.646 36.9815 149.547 37.2533Z",
    fill: "#263238"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.414 36.1338C151.414 36.1338 152.6 35.8201 152.726 36.9493",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M149.863 35.8186C149.863 35.8186 148.817 35.4474 148.488 36.3413",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M150.666 42.9426L152.349 42.2578",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M149.404 31.8857C149.404 31.8857 147.407 29.5124 145.906 31.2584C144.406 33.0044 144.861 35.6339 147.532 35.7593C150.203 35.8848 153.215 33.2606 153.215 33.2606C153.215 33.2606 152.901 36.6951 153.648 37.8817C154.396 39.0684 154.961 39.8786 154.961 39.8786C154.961 39.8786 156.006 40.5635 157.773 39.1938C159.54 37.8242 159.958 34.489 158.709 32.2569C157.459 30.0247 155.274 28.7596 152.65 29.6431C150.026 30.5265 149.404 31.8857 149.404 31.8857Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M153.724 39.8195C153.724 39.8195 155.972 37.7599 155.972 38.9465C155.972 40.1332 154.926 41.1944 154.101 40.9435",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M153.724 39.8195C153.724 39.8195 155.972 37.7599 155.972 38.9465C155.972 40.1332 154.926 41.1944 154.101 40.9435",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M148.907 40.7734C149.202 40.9861 149.557 41.1006 149.921 41.1006C150.285 41.1006 150.64 40.9861 150.935 40.7734",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M160.519 44.7172C164.511 40.4694 164.303 33.7899 160.055 29.7981C155.808 25.8064 149.128 26.014 145.136 30.2618C141.145 34.5096 141.352 41.1891 145.6 45.1808C149.848 49.1726 156.527 48.965 160.519 44.7172Z",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M224.654 123.35C230.653 121.947 234.379 115.946 232.977 109.947C231.574 103.948 225.573 100.222 219.574 101.624C213.575 103.027 209.849 109.027 211.251 115.027C212.654 121.026 218.654 124.752 224.654 123.35Z",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M225.911 115.774C225.911 116.508 225.693 117.226 225.285 117.836C224.878 118.446 224.298 118.922 223.62 119.203C222.942 119.484 222.195 119.558 221.475 119.414C220.755 119.271 220.094 118.918 219.575 118.399C219.056 117.879 218.702 117.218 218.559 116.498C218.416 115.778 218.489 115.032 218.77 114.354C219.051 113.676 219.527 113.096 220.137 112.688C220.748 112.28 221.465 112.062 222.199 112.062C223.184 112.062 224.128 112.454 224.824 113.15C225.52 113.846 225.911 114.79 225.911 115.774Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M227.508 118.241C228.309 117.241 228.811 116.036 228.956 114.764C229.102 113.492 228.885 112.204 228.331 111.05C227.776 109.895 226.907 108.921 225.823 108.239C224.74 107.557 223.485 107.195 222.205 107.195C220.924 107.195 219.669 107.557 218.586 108.239C217.502 108.921 216.633 109.895 216.078 111.05C215.524 112.204 215.307 113.492 215.453 114.764C215.598 116.036 216.1 117.241 216.901 118.241H227.508Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224.863 116.317H219.395C219.075 116.317 218.758 116.254 218.462 116.132C218.167 116.01 217.898 115.83 217.672 115.604C217.446 115.378 217.266 115.109 217.144 114.814C217.022 114.518 216.959 114.201 216.959 113.881C216.958 113.561 217.02 113.244 217.143 112.948C217.265 112.652 217.444 112.384 217.67 112.157C217.897 111.931 218.166 111.752 218.461 111.629C218.757 111.507 219.074 111.445 219.395 111.445H224.863C225.183 111.445 225.5 111.507 225.796 111.629C226.091 111.752 226.36 111.931 226.587 112.157C226.813 112.384 226.992 112.652 227.115 112.948C227.237 113.244 227.299 113.561 227.299 113.881C227.299 114.527 227.042 115.147 226.585 115.604C226.128 116.061 225.509 116.317 224.863 116.317Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M218.07 113.69C218.182 113.377 218.386 113.104 218.656 112.908C218.925 112.713 219.248 112.603 219.581 112.594C219.914 112.585 220.242 112.677 220.521 112.858C220.801 113.038 221.02 113.299 221.149 113.607",
    stroke: "#263238",
    strokeWidth: 1.68661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M223.184 113.69C223.296 113.377 223.5 113.104 223.77 112.908C224.04 112.713 224.362 112.603 224.695 112.594C225.028 112.585 225.356 112.677 225.636 112.858C225.916 113.038 226.134 113.299 226.263 113.607",
    stroke: "#263238",
    strokeWidth: 1.68661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M221.315 114.82C221.339 115.05 221.448 115.263 221.62 115.417C221.791 115.572 222.014 115.657 222.245 115.657C222.477 115.657 222.699 115.572 222.871 115.417C223.043 115.263 223.152 115.05 223.176 114.82H221.315Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M230.989 115.209C230.895 115.209 230.803 115.191 230.717 115.155C230.63 115.119 230.552 115.067 230.486 115.001C230.42 114.935 230.368 114.856 230.332 114.77C230.296 114.684 230.278 114.592 230.278 114.498V112.883C230.278 112.789 230.296 112.697 230.332 112.611C230.368 112.525 230.42 112.446 230.486 112.38C230.552 112.314 230.63 112.262 230.717 112.226C230.803 112.19 230.895 112.172 230.989 112.172C231.082 112.172 231.175 112.19 231.261 112.226C231.347 112.262 231.425 112.314 231.491 112.38C231.558 112.446 231.61 112.525 231.646 112.611C231.681 112.697 231.7 112.789 231.7 112.883V114.482C231.702 114.577 231.685 114.671 231.65 114.759C231.615 114.847 231.563 114.928 231.497 114.995C231.431 115.063 231.352 115.117 231.265 115.154C231.177 115.19 231.083 115.209 230.989 115.209Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M213.227 115.209C213.134 115.209 213.041 115.191 212.955 115.155C212.869 115.119 212.79 115.067 212.724 115.001C212.658 114.935 212.606 114.856 212.57 114.77C212.534 114.684 212.516 114.592 212.516 114.498V112.883C212.516 112.789 212.534 112.697 212.57 112.611C212.606 112.525 212.658 112.446 212.724 112.38C212.79 112.314 212.869 112.262 212.955 112.226C213.041 112.19 213.134 112.172 213.227 112.172C213.32 112.172 213.413 112.19 213.499 112.226C213.585 112.262 213.664 112.314 213.73 112.38C213.796 112.446 213.848 112.525 213.884 112.611C213.92 112.697 213.938 112.789 213.938 112.883V114.482C213.94 114.577 213.923 114.671 213.888 114.759C213.854 114.847 213.802 114.928 213.735 114.995C213.669 115.063 213.59 115.117 213.503 115.154C213.416 115.19 213.322 115.209 213.227 115.209Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M214.546 112.973C214.348 112.972 214.159 112.893 214.02 112.753C213.881 112.613 213.803 112.423 213.803 112.226V111.055C213.801 109.786 214.18 108.546 214.891 107.495C214.942 107.405 215.011 107.327 215.093 107.266C215.176 107.204 215.27 107.16 215.371 107.137C215.471 107.113 215.575 107.111 215.677 107.13C215.778 107.149 215.874 107.188 215.96 107.246C216.045 107.304 216.117 107.379 216.172 107.466C216.227 107.553 216.264 107.651 216.279 107.753C216.295 107.855 216.289 107.959 216.262 108.058C216.236 108.158 216.189 108.251 216.124 108.331C215.581 109.135 215.291 110.084 215.293 111.055V112.226C215.293 112.424 215.214 112.614 215.074 112.754C214.934 112.895 214.744 112.973 214.546 112.973Z",
    fill: "#263238"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M228.98 108.291C228.919 108.291 228.858 108.276 228.805 108.246C228.751 108.217 228.705 108.175 228.672 108.123C228.192 107.409 227.544 106.824 226.785 106.42C226.025 106.016 225.177 105.805 224.317 105.807H220.166C219.306 105.805 218.459 106.016 217.699 106.42C216.939 106.824 216.291 107.409 215.812 108.123C215.756 108.206 215.669 108.263 215.571 108.281C215.473 108.3 215.372 108.279 215.289 108.223C215.248 108.195 215.212 108.16 215.185 108.119C215.157 108.077 215.138 108.031 215.129 107.982C215.12 107.933 215.12 107.883 215.131 107.835C215.141 107.786 215.161 107.74 215.19 107.7C215.738 106.885 216.478 106.217 217.345 105.756C218.212 105.295 219.179 105.054 220.161 105.055H224.312C225.295 105.054 226.264 105.296 227.132 105.758C227.999 106.22 228.74 106.889 229.289 107.705C229.317 107.746 229.336 107.792 229.347 107.841C229.357 107.89 229.357 107.94 229.347 107.989C229.337 108.037 229.318 108.084 229.29 108.125C229.262 108.166 229.226 108.201 229.184 108.228C229.124 108.268 229.053 108.29 228.98 108.291Z",
    fill: "#263238"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M229.943 112.978C229.745 112.978 229.555 112.9 229.415 112.759C229.275 112.619 229.196 112.429 229.196 112.231V111.06C229.198 110.089 228.908 109.14 228.365 108.336C228.302 108.255 228.257 108.162 228.232 108.063C228.207 107.964 228.203 107.861 228.219 107.76C228.236 107.659 228.273 107.562 228.328 107.476C228.383 107.39 228.456 107.317 228.541 107.26C228.625 107.203 228.721 107.164 228.822 107.145C228.922 107.127 229.026 107.129 229.125 107.152C229.225 107.175 229.319 107.218 229.401 107.279C229.483 107.34 229.552 107.417 229.604 107.505C230.313 108.555 230.69 109.793 230.686 111.06V112.231C230.686 112.428 230.608 112.618 230.469 112.758C230.33 112.898 230.141 112.977 229.943 112.978Z",
    fill: "#263238"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M214.639 116.259C214.248 116.259 213.873 116.104 213.596 115.827C213.32 115.551 213.165 115.176 213.165 114.785V112.443C213.165 112.052 213.32 111.677 213.596 111.401C213.873 111.124 214.248 110.969 214.639 110.969C215.03 110.969 215.405 111.124 215.681 111.401C215.958 111.677 216.113 112.052 216.113 112.443V114.785C216.113 115.176 215.958 115.551 215.681 115.827C215.405 116.104 215.03 116.259 214.639 116.259Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M214.787 110.969H214.484V116.259H214.787V110.969Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M231.147 112.443C231.147 111.629 230.487 110.969 229.673 110.969C228.859 110.969 228.199 111.629 228.199 112.443V114.785C228.199 115.599 228.859 116.259 229.673 116.259C230.487 116.259 231.147 115.599 231.147 114.785V112.443Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M229.822 110.969H229.519V116.259H229.822V110.969Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M222.243 110.486C222.762 110.484 223.273 110.353 223.729 110.105C224.185 109.856 224.573 109.499 224.857 109.064L225.5 108.066C224.48 107.501 223.333 107.21 222.168 107.219C221.003 107.228 219.86 107.538 218.85 108.118L219.812 109.32C220.105 109.683 220.475 109.976 220.896 110.177C221.316 110.379 221.776 110.484 222.243 110.486Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M222.283 116.925C222.345 116.925 222.394 116.875 222.394 116.814C222.394 116.753 222.345 116.703 222.283 116.703C222.222 116.703 222.172 116.753 222.172 116.814C222.172 116.875 222.222 116.925 222.283 116.925Z",
    fill: "#263238"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M222.394 117.2C222.393 117.171 222.381 117.144 222.36 117.124C222.339 117.105 222.312 117.094 222.283 117.094C222.269 117.093 222.255 117.095 222.241 117.1C222.228 117.105 222.216 117.113 222.205 117.123C222.195 117.133 222.187 117.145 222.181 117.158C222.175 117.171 222.172 117.185 222.172 117.2C222.172 117.229 222.184 117.257 222.205 117.278C222.226 117.299 222.254 117.31 222.283 117.31C222.313 117.31 222.341 117.299 222.362 117.278C222.383 117.257 222.394 117.229 222.394 117.2Z",
    fill: "#263238"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M221.967 117.145C221.995 117.136 222.018 117.117 222.032 117.091C222.046 117.065 222.049 117.035 222.041 117.007C222.03 116.98 222.01 116.957 221.984 116.943C221.957 116.93 221.927 116.926 221.898 116.933C221.87 116.942 221.847 116.961 221.833 116.987C221.819 117.012 221.816 117.043 221.824 117.071C221.835 117.098 221.855 117.121 221.882 117.135C221.908 117.148 221.938 117.152 221.967 117.145Z",
    fill: "#263238"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M222.656 117.146C222.684 117.137 222.707 117.118 222.721 117.092C222.735 117.066 222.738 117.036 222.73 117.008C222.72 116.98 222.7 116.957 222.673 116.943C222.647 116.929 222.616 116.926 222.587 116.934C222.574 116.939 222.561 116.945 222.55 116.955C222.539 116.964 222.53 116.975 222.523 116.988C222.517 117.001 222.513 117.015 222.512 117.029C222.512 117.044 222.514 117.058 222.519 117.072C222.527 117.1 222.546 117.123 222.572 117.137C222.598 117.151 222.628 117.154 222.656 117.146Z",
    fill: "#263238"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M208.405 55.4847H166.809V36.953V32.0391L171.728 36.953H208.405V55.4847Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M208.405 82.331H166.809V63.8045V58.8906L171.728 63.8045H208.405V82.331Z",
    fill: "#D6D6D6",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 43.3281H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 43.3281H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 43.3281H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 46.4141H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 46.4141H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 49.4844H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 49.4844H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 49.4844H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 69.3359H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 69.3359H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 69.3359H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 72.4141H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 72.4141H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 75.4922H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 75.4922H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 75.4922H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M166.809 157.816H208.405V113V108.086L203.486 113H166.809V157.816Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 119.117H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 119.117H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 119.117H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 122.195H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 122.195H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 125.273H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 125.273H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 125.273H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 127.789H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 127.789H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 127.789H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 130.867H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 130.867H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 133.938H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 133.938H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 133.938H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 136.461H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 136.461H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 136.461H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 139.531H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 139.531H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 142.609H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 142.609H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 142.609H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 145.125H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 145.125H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 145.125H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 148.203H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 148.203H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 151.281H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 151.281H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 151.281H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M222.11 182.741C228.271 182.741 233.266 177.746 233.266 171.585C233.266 165.424 228.271 160.43 222.11 160.43C215.949 160.43 210.955 165.424 210.955 171.585C210.955 177.746 215.949 182.741 222.11 182.741Z",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M225.911 174.87C225.912 175.605 225.695 176.323 225.288 176.934C224.881 177.545 224.301 178.021 223.623 178.303C222.945 178.585 222.199 178.659 221.478 178.517C220.758 178.374 220.096 178.021 219.577 177.502C219.057 176.983 218.703 176.322 218.559 175.602C218.416 174.882 218.489 174.135 218.77 173.456C219.051 172.778 219.526 172.198 220.137 171.79C220.747 171.382 221.465 171.164 222.199 171.164C223.183 171.164 224.126 171.554 224.822 172.249C225.518 172.944 225.91 173.887 225.911 174.87Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M227.508 177.342C228.309 176.343 228.811 175.138 228.956 173.865C229.102 172.593 228.885 171.306 228.331 170.151C227.776 168.997 226.907 168.023 225.823 167.341C224.74 166.659 223.485 166.297 222.205 166.297C220.924 166.297 219.669 166.659 218.586 167.341C217.502 168.023 216.633 168.997 216.078 170.151C215.524 171.306 215.307 172.593 215.453 173.865C215.598 175.138 216.1 176.343 216.901 177.342H227.508Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M224.863 175.419H219.395C219.075 175.419 218.758 175.356 218.462 175.234C218.167 175.111 217.898 174.932 217.672 174.705C217.446 174.479 217.266 174.211 217.144 173.915C217.021 173.62 216.958 173.303 216.958 172.983C216.958 172.663 217.021 172.346 217.144 172.051C217.266 171.755 217.446 171.487 217.672 171.26C217.898 171.034 218.167 170.855 218.462 170.732C218.758 170.61 219.075 170.547 219.395 170.547H224.863C225.182 170.547 225.499 170.61 225.795 170.732C226.09 170.855 226.359 171.034 226.585 171.26C226.811 171.487 226.991 171.755 227.113 172.051C227.236 172.346 227.299 172.663 227.299 172.983C227.299 173.629 227.042 174.249 226.585 174.705C226.128 175.162 225.509 175.419 224.863 175.419Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M218.07 172.784C218.182 172.47 218.386 172.198 218.656 172.002C218.925 171.807 219.248 171.697 219.581 171.688C219.914 171.679 220.242 171.771 220.521 171.952C220.801 172.132 221.02 172.393 221.149 172.7",
    stroke: "#263238",
    strokeWidth: 1.68661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M223.184 172.784C223.296 172.47 223.5 172.198 223.77 172.002C224.04 171.807 224.362 171.697 224.695 171.688C225.028 171.679 225.356 171.771 225.636 171.952C225.916 172.132 226.134 172.393 226.263 172.7",
    stroke: "#263238",
    strokeWidth: 1.68661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M221.315 173.906C221.339 174.136 221.448 174.349 221.62 174.503C221.791 174.658 222.014 174.743 222.245 174.743C222.477 174.743 222.699 174.658 222.871 174.503C223.043 174.349 223.152 174.136 223.176 173.906H221.315Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M230.989 174.298C230.8 174.298 230.619 174.223 230.486 174.089C230.353 173.956 230.278 173.775 230.278 173.587V171.977C230.278 171.788 230.353 171.607 230.486 171.474C230.619 171.341 230.8 171.266 230.989 171.266C231.177 171.266 231.358 171.341 231.491 171.474C231.625 171.607 231.7 171.788 231.7 171.977V173.592C231.698 173.78 231.623 173.959 231.49 174.091C231.356 174.223 231.176 174.298 230.989 174.298Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M213.227 174.298C213.038 174.298 212.858 174.223 212.724 174.089C212.591 173.956 212.516 173.775 212.516 173.587V171.977C212.516 171.788 212.591 171.607 212.724 171.474C212.858 171.341 213.038 171.266 213.227 171.266C213.416 171.266 213.596 171.341 213.73 171.474C213.863 171.607 213.938 171.788 213.938 171.977V173.592C213.937 173.78 213.861 173.959 213.728 174.091C213.595 174.223 213.415 174.298 213.227 174.298Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M214.546 172.085C214.348 172.084 214.159 172.004 214.02 171.864C213.881 171.724 213.803 171.535 213.803 171.337V170.161C213.802 168.893 214.18 167.653 214.891 166.601C215.008 166.454 215.177 166.357 215.363 166.329C215.549 166.301 215.738 166.344 215.894 166.449C216.05 166.555 216.16 166.715 216.203 166.898C216.245 167.082 216.217 167.274 216.124 167.438C215.581 168.242 215.291 169.191 215.293 170.161V171.337C215.293 171.536 215.214 171.726 215.074 171.866C214.934 172.006 214.744 172.085 214.546 172.085Z",
    fill: "#263238"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M228.984 167.387C228.923 167.387 228.863 167.372 228.809 167.344C228.756 167.315 228.71 167.275 228.675 167.225C228.197 166.509 227.549 165.923 226.789 165.518C226.029 165.113 225.181 164.902 224.321 164.904H220.17C219.31 164.904 218.463 165.116 217.704 165.52C216.945 165.923 216.297 166.507 215.815 167.22C215.788 167.26 215.753 167.295 215.712 167.322C215.671 167.349 215.625 167.367 215.577 167.376C215.529 167.386 215.48 167.385 215.432 167.375C215.384 167.366 215.338 167.346 215.298 167.319C215.257 167.291 215.223 167.256 215.196 167.215C215.169 167.175 215.15 167.129 215.141 167.081C215.132 167.033 215.132 166.983 215.142 166.935C215.152 166.887 215.171 166.842 215.198 166.801C215.747 165.986 216.487 165.319 217.354 164.858C218.221 164.396 219.188 164.155 220.17 164.156H224.321C225.304 164.157 226.272 164.398 227.14 164.861C228.007 165.323 228.748 165.991 229.297 166.807C229.325 166.848 229.345 166.894 229.355 166.942C229.365 166.991 229.365 167.041 229.356 167.09C229.346 167.139 229.326 167.185 229.298 167.226C229.27 167.267 229.234 167.302 229.193 167.329C229.13 167.369 229.057 167.389 228.984 167.387Z",
    fill: "#263238"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M229.946 172.085C229.748 172.085 229.558 172.006 229.418 171.866C229.278 171.726 229.199 171.535 229.199 171.337V170.161C229.2 169.192 228.91 168.245 228.368 167.443C228.311 167.361 228.27 167.27 228.249 167.172C228.228 167.075 228.226 166.975 228.244 166.878C228.262 166.78 228.3 166.687 228.354 166.604C228.408 166.521 228.479 166.449 228.561 166.394C228.644 166.338 228.736 166.299 228.833 166.28C228.931 166.261 229.031 166.261 229.128 166.281C229.226 166.3 229.318 166.339 229.4 166.395C229.482 166.451 229.552 166.523 229.607 166.606C230.315 167.656 230.692 168.894 230.689 170.161V171.337C230.689 171.535 230.611 171.724 230.472 171.864C230.332 172.004 230.144 172.083 229.946 172.085Z",
    fill: "#263238"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M214.639 175.366C214.248 175.366 213.873 175.211 213.596 174.934C213.32 174.658 213.165 174.283 213.165 173.892V171.544C213.165 171.154 213.32 170.779 213.596 170.502C213.873 170.226 214.248 170.07 214.639 170.07C215.03 170.07 215.405 170.226 215.681 170.502C215.958 170.779 216.113 171.154 216.113 171.544V173.892C216.112 174.282 215.956 174.656 215.68 174.933C215.403 175.209 215.029 175.364 214.639 175.366Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M214.787 170.07H214.484V175.361H214.787V170.07Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M231.147 171.544C231.147 170.73 230.487 170.07 229.673 170.07C228.859 170.07 228.199 170.73 228.199 171.544V173.886C228.199 174.701 228.859 175.361 229.673 175.361C230.487 175.361 231.147 174.701 231.147 173.886V171.544Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M229.822 170.07H229.519V175.361H229.822V170.07Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M222.243 169.581C222.762 169.579 223.273 169.448 223.729 169.2C224.185 168.951 224.573 168.594 224.857 168.159L225.5 167.166C224.48 166.603 223.333 166.312 222.169 166.32C221.004 166.329 219.862 166.636 218.85 167.213L219.812 168.415C220.105 168.778 220.475 169.071 220.896 169.273C221.316 169.474 221.776 169.58 222.243 169.581Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M222.283 176.019C222.345 176.019 222.394 175.969 222.394 175.908C222.394 175.847 222.345 175.797 222.283 175.797C222.222 175.797 222.172 175.847 222.172 175.908C222.172 175.969 222.222 176.019 222.283 176.019Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M222.283 176.417C222.345 176.417 222.394 176.368 222.394 176.306C222.394 176.245 222.345 176.195 222.283 176.195C222.222 176.195 222.172 176.245 222.172 176.306C222.172 176.368 222.222 176.417 222.283 176.417Z",
    fill: "#263238"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M221.966 176.238C221.994 176.23 222.017 176.211 222.031 176.185C222.045 176.159 222.048 176.129 222.04 176.101C222.029 176.073 222.009 176.051 221.982 176.037C221.956 176.023 221.926 176.02 221.897 176.027C221.87 176.037 221.847 176.056 221.834 176.081C221.82 176.107 221.816 176.136 221.823 176.164C221.827 176.179 221.834 176.192 221.844 176.204C221.854 176.215 221.865 176.225 221.879 176.232C221.892 176.239 221.907 176.243 221.922 176.244C221.937 176.245 221.952 176.243 221.966 176.238Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M222.656 176.239C222.684 176.231 222.707 176.212 222.721 176.186C222.735 176.16 222.738 176.13 222.73 176.102C222.72 176.074 222.7 176.05 222.673 176.036C222.647 176.023 222.616 176.02 222.587 176.028C222.574 176.032 222.561 176.039 222.55 176.048C222.539 176.058 222.53 176.069 222.523 176.082C222.517 176.095 222.513 176.109 222.512 176.123C222.512 176.138 222.514 176.152 222.519 176.165C222.522 176.18 222.529 176.193 222.538 176.205C222.547 176.216 222.558 176.226 222.571 176.233C222.584 176.24 222.598 176.244 222.613 176.245C222.627 176.246 222.642 176.244 222.656 176.239Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M166.809 198.553H208.405V172.101V167.188L203.486 172.101H166.809V198.553Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 178.211H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 178.211H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 178.211H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 181.297H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 181.297H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 184.367H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 184.367H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 184.367H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M194.591 186.883H204.383",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M180.875 186.883H192.062",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 186.883H178.926",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M190.103 189.961H204.369",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 189.961H187.599",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M201.574 193.039H204.37",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M185.923 193.039H199.348",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M172.497 193.039H183.684",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M229.384 12.3203H207.805C207.578 13.5154 206.942 14.5943 206.006 15.371C205.07 16.1477 203.893 16.5737 202.676 16.5755H171.782C170.565 16.5737 169.388 16.1477 168.451 15.371C167.515 14.5943 166.88 13.5154 166.653 12.3203H145.1C143.298 12.3203 141.569 13.0363 140.295 14.3108C139.02 15.5852 138.304 17.3138 138.304 19.1161V201.558C138.304 203.36 139.02 205.089 140.295 206.363C141.569 207.638 143.298 208.354 145.1 208.354H229.384C231.186 208.354 232.915 207.638 234.189 206.363C235.464 205.089 236.18 203.36 236.18 201.558V19.1161C236.18 17.3138 235.464 15.5852 234.189 14.3108C232.915 13.0363 231.186 12.3203 229.384 12.3203Z",
    stroke: "#263238",
    strokeWidth: 1.68661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M236.18 24.6312V19.1214C236.18 17.319 235.464 15.5905 234.189 14.316C232.915 13.0415 231.186 12.3255 229.384 12.3255H207.805C207.578 13.5207 206.942 14.5995 206.006 15.3762C205.07 16.1529 203.893 16.5789 202.676 16.5808H171.782C170.564 16.5787 169.386 16.1519 168.45 15.3742C167.514 14.5964 166.878 13.5164 166.653 12.3203H145.1C143.298 12.3203 141.569 13.0363 140.295 14.3108C139.02 15.5852 138.304 17.3138 138.304 19.1161V24.6312H236.18Z",
    stroke: "#263238",
    strokeWidth: 1.68661,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M147.275 17.2463C147.275 18.5846 145.769 19.0655 145.764 20.0849V20.1529H147.222V20.6077H145.278V20.226C145.278 18.8146 146.794 18.5114 146.794 17.2463C146.794 16.7863 146.642 16.5458 146.271 16.5458C145.9 16.5458 145.748 16.8072 145.748 17.1993V17.5914H145.288V17.2463C145.288 16.5668 145.597 16.1172 146.282 16.1172C146.966 16.1172 147.275 16.5668 147.275 17.2463Z",
    fill: "#263238"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M149.697 17.2437V17.3587C149.719 17.5464 149.681 17.7363 149.586 17.9001C149.492 18.064 149.348 18.1931 149.174 18.2683C149.35 18.344 149.496 18.4747 149.59 18.6408C149.684 18.8068 149.722 18.999 149.697 19.1884V19.5281C149.697 20.2077 149.378 20.6521 148.699 20.6521C148.019 20.6521 147.7 20.2077 147.7 19.5281V19.2249H148.165V19.5595C148.165 19.962 148.327 20.2025 148.688 20.2025C149.049 20.2025 149.211 19.9673 149.211 19.5177V19.1779C149.211 18.7388 149.023 18.5297 148.652 18.514H148.359V18.0749H148.652C148.728 18.076 148.805 18.0602 148.875 18.0285C148.945 17.9969 149.007 17.9502 149.057 17.8918C149.106 17.8334 149.143 17.7647 149.163 17.6907C149.184 17.6166 149.187 17.539 149.174 17.4633V17.2437C149.174 16.7889 149.012 16.5537 148.652 16.5537C148.291 16.5537 148.129 16.7994 148.129 17.2019V17.4319H147.664V17.2437C147.664 16.5641 147.982 16.125 148.662 16.125C149.342 16.125 149.697 16.5589 149.697 17.2437Z",
    fill: "#263238"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M150.647 17.5781V18.195H150.171V17.5781H150.647ZM150.647 19.9933V20.6101H150.171V19.9933H150.647Z",
    fill: "#263238"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M151.646 17.9676C151.711 17.8514 151.807 17.7556 151.923 17.691C152.04 17.6263 152.172 17.5954 152.305 17.6016C152.874 17.6016 153.131 18.0198 153.131 18.6472V19.5149C153.131 20.1945 152.806 20.6389 152.127 20.6389C151.447 20.6389 151.134 20.1945 151.134 19.5149V19.217H151.594V19.5463C151.594 19.9488 151.761 20.1893 152.116 20.1893C152.472 20.1893 152.639 19.9488 152.639 19.5463V18.6942C152.639 18.2917 152.477 18.0512 152.116 18.0512C152.05 18.0446 151.983 18.052 151.92 18.073C151.857 18.0939 151.798 18.1279 151.749 18.1728C151.7 18.2176 151.661 18.2723 151.634 18.3333C151.607 18.3943 151.593 18.4603 151.594 18.5269V18.6262H151.128L151.249 16.1641H153V16.6084H151.693L151.646 17.9676Z",
    fill: "#263238"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M155.598 17.2464V17.3248H155.149V17.2098C155.149 16.8125 154.982 16.5773 154.626 16.5773C154.271 16.5773 154.103 16.8177 154.103 17.2934V18.2919C154.154 18.1453 154.252 18.0194 154.381 17.9335C154.511 17.8476 154.665 17.8064 154.819 17.8162C155.389 17.8162 155.645 18.2239 155.645 18.8617V19.5308C155.645 20.2104 155.311 20.6548 154.631 20.6548C153.952 20.6548 153.581 20.2052 153.581 19.5256V17.2464C153.581 16.5407 153.894 16.1016 154.6 16.1016C155.306 16.1016 155.598 16.5564 155.598 17.2464ZM154.072 18.9035V19.5674C154.072 19.97 154.239 20.2104 154.595 20.2104C154.95 20.2104 155.117 19.97 155.117 19.5674V18.8931C155.117 18.4958 154.945 18.2553 154.595 18.2553C154.244 18.2553 154.072 18.4958 154.072 18.8931V18.9035Z",
    fill: "#263238"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M210.384 17.4297H209.129V20.561H210.384V17.4297Z",
    fill: "#263238"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M212.055 16.7969H210.8V20.5555H212.055V16.7969Z",
    fill: "#263238"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M213.727 16.3516H212.472V20.5545H213.727V16.3516Z",
    fill: "#263238"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M215.408 15.5781H214.154V20.56H215.408V15.5781Z",
    fill: "#263238"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M230.899 20.4726H223.381V15.8828H230.899V20.4726ZM223.8 20.0596H230.48V16.301H223.8V20.0596Z",
    fill: "#263238"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M228.395 16.7578H224.427V19.6068H228.395V16.7578Z",
    fill: "#263238"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M231.586 17.6406H230.64V18.7227H231.586V17.6406Z",
    fill: "#263238"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M220.627 19.4699C220.578 19.4708 220.529 19.4581 220.486 19.4333C218.954 18.5237 217.946 19.3654 217.904 19.402C217.877 19.4296 217.844 19.4513 217.808 19.4658C217.772 19.4802 217.733 19.4871 217.694 19.486C217.656 19.4848 217.618 19.4757 217.582 19.4592C217.547 19.4427 217.516 19.4191 217.49 19.3899C217.465 19.3607 217.446 19.3266 217.434 19.2896C217.422 19.2526 217.418 19.2136 217.422 19.175C217.426 19.1364 217.438 19.099 217.457 19.0652C217.476 19.0314 217.502 19.0019 217.533 18.9785C217.585 18.9315 218.881 17.8232 220.774 18.9472C220.836 18.987 220.881 19.0496 220.899 19.1217C220.916 19.1938 220.905 19.2698 220.868 19.334C220.843 19.3757 220.808 19.4102 220.766 19.4341C220.724 19.4579 220.676 19.4703 220.627 19.4699Z",
    fill: "#263238"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M221.189 18.5337C221.139 18.5328 221.091 18.5183 221.048 18.4919C218.837 17.1798 217.347 18.4501 217.331 18.4605C217.304 18.4846 217.272 18.503 217.237 18.5146C217.203 18.5263 217.166 18.5311 217.13 18.5287C217.094 18.5262 217.058 18.5167 217.025 18.5005C216.993 18.4843 216.963 18.4619 216.939 18.4344C216.915 18.4069 216.897 18.375 216.885 18.3405C216.874 18.3059 216.869 18.2694 216.871 18.233C216.874 18.1965 216.883 18.161 216.899 18.1283C216.916 18.0956 216.938 18.0664 216.965 18.0423C216.965 18.0423 218.774 16.4741 221.336 18.011C221.399 18.0499 221.445 18.1125 221.463 18.185C221.48 18.2575 221.468 18.334 221.43 18.3978C221.405 18.4392 221.369 18.4734 221.327 18.4972C221.285 18.521 221.238 18.5336 221.189 18.5337Z",
    fill: "#263238"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M221.705 17.437C221.653 17.436 221.603 17.4216 221.559 17.3952C218.757 15.7329 216.896 17.3011 216.817 17.3691C216.76 17.4121 216.689 17.4319 216.618 17.4246C216.547 17.4173 216.482 17.3835 216.435 17.3299C216.388 17.2763 216.363 17.2068 216.365 17.1356C216.367 17.0643 216.396 16.9964 216.446 16.9457C216.472 16.9457 218.683 15.0324 221.846 16.9143C221.878 16.9332 221.906 16.9581 221.928 16.9878C221.95 17.0174 221.967 17.0512 221.976 17.0871C221.985 17.1231 221.987 17.1604 221.982 17.1972C221.977 17.2339 221.964 17.2692 221.945 17.3011C221.92 17.3422 221.885 17.3761 221.843 17.3999C221.801 17.4236 221.753 17.4364 221.705 17.437Z",
    fill: "#263238"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M219.789 19.9427C219.79 20.0827 219.749 20.2199 219.672 20.3367C219.595 20.4536 219.485 20.5448 219.356 20.5989C219.226 20.653 219.084 20.6674 218.947 20.6403C218.809 20.6133 218.683 20.5459 218.584 20.4469C218.485 20.3479 218.418 20.2217 218.391 20.0843C218.364 19.9469 218.378 19.8046 218.432 19.6754C218.486 19.5463 218.577 19.4361 218.694 19.359C218.811 19.2818 218.948 19.2412 219.088 19.2422C219.274 19.2422 219.452 19.316 219.584 19.4474C219.715 19.5787 219.789 19.7569 219.789 19.9427Z",
    fill: "#263238"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M228.331 216.68H239.308",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3237 216.68H224.676",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02734 216.68H14.5289",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3183 146.281H74.3306V215.703H82.3183V146.281Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M18.98 171.422V176.305H50.8158V171.422H18.98Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2468 154.57H17.3643V174.106H22.2468V154.57Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M24.284 174.185C24.284 174.772 24.1682 175.354 23.9433 175.897C23.7184 176.439 23.3887 176.932 22.9731 177.347C22.5575 177.762 22.0641 178.091 21.5213 178.316C20.9784 178.54 20.3966 178.655 19.8092 178.654C19.6629 178.654 19.5165 178.654 19.3753 178.654C18.5611 178.574 17.7846 178.272 17.1301 177.781C16.4757 177.29 15.9684 176.629 15.6634 175.869C15.3584 175.11 15.2674 174.282 15.4002 173.475C15.5331 172.667 15.8848 171.912 16.417 171.291C16.9492 170.669 17.6416 170.206 18.4189 169.95C19.1962 169.695 20.0286 169.657 20.8257 169.842C21.6227 170.027 22.3539 170.426 22.9397 170.998C23.5255 171.569 23.9434 172.29 24.1481 173.082C24.2374 173.443 24.283 173.813 24.284 174.185Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6209 157.585C24.6181 158.77 24.1456 159.906 23.3069 160.744C22.4682 161.582 21.3316 162.053 20.1461 162.054C19.9998 162.054 19.8534 162.054 19.707 162.054C18.8924 161.976 18.1148 161.676 17.4588 161.187C16.8028 160.698 16.2935 160.038 15.9864 159.279C15.6792 158.521 15.5859 157.693 15.7167 156.885C15.8474 156.077 16.1972 155.321 16.7279 154.698C17.2587 154.075 17.95 153.609 18.7269 153.352C19.5037 153.095 20.3362 153.055 21.1339 153.238C21.9315 153.421 22.6638 153.819 23.2509 154.389C23.8381 154.959 24.2577 155.679 24.4641 156.471C24.5645 156.834 24.6172 157.208 24.6209 157.585Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6265 145.449L26.1182 148.953L27.4664 151.457L33.9747 147.953L32.6265 145.449Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0564 148.219L31.8519 149.944L29.8027 146.144L33.0125 144.414C33.2643 144.276 33.5412 144.189 33.8269 144.16C34.1126 144.13 34.4013 144.158 34.676 144.242C34.9508 144.326 35.2059 144.464 35.4266 144.648C35.6472 144.832 35.8289 145.058 35.9608 145.313C36.2231 145.819 36.2753 146.408 36.106 146.952C35.9366 147.496 35.5595 147.951 35.0564 148.219Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0154 132.11L20.7853 145.367L17.9468 145.32L18.1716 132.062L21.0154 132.11Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7724 131.313L21.7149 134.972L17.397 134.868L17.4545 131.209C17.4592 130.925 17.5198 130.645 17.6327 130.385C17.7457 130.125 17.9087 129.89 18.1126 129.693C18.3165 129.496 18.5572 129.341 18.821 129.237C19.0848 129.132 19.3665 129.081 19.6501 129.086C19.9365 129.09 20.2193 129.151 20.4818 129.266C20.7444 129.381 20.9814 129.547 21.179 129.754C21.3767 129.961 21.531 130.206 21.6329 130.474C21.7348 130.742 21.7822 131.027 21.7724 131.313Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M31.631 136.927L25.3945 148.626L22.8853 147.293L29.1165 135.594L31.631 136.927Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6722 136.562L30.9627 139.777L27.1519 137.754L28.856 134.534C29.1257 134.03 29.5837 133.653 30.1302 133.486C30.6767 133.318 31.2673 133.374 31.773 133.64C32.2793 133.909 32.6583 134.367 32.8269 134.915C32.9955 135.463 32.9398 136.055 32.6722 136.562Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9271 136.867L17.106 148.598L14.5916 149.926L8.4126 138.195L10.9271 136.867Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7289 145.373C16.6372 144.83 16.3867 144.327 16.009 143.927C15.6312 143.527 15.1433 143.247 14.6069 143.125C14.0705 143.002 13.5097 143.041 12.9956 143.237C12.4815 143.433 12.037 143.778 11.7186 144.226C11.4001 144.675 11.222 145.208 11.2066 145.758C11.1913 146.308 11.3395 146.851 11.6324 147.316C11.9254 147.782 12.3499 148.151 12.8523 148.375C13.3548 148.599 13.9125 148.67 14.4549 148.577C15.181 148.453 15.8283 148.046 16.2547 147.445C16.681 146.844 16.8515 146.099 16.7289 145.373Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4529 145.742C20.9889 145.742 22.234 144.497 22.234 142.961C22.234 141.425 20.9889 140.18 19.4529 140.18C17.917 140.18 16.6719 141.425 16.6719 142.961C16.6719 144.497 17.917 145.742 19.4529 145.742Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5132 144.563C28.5969 144.02 28.5174 143.463 28.2847 142.965C28.0521 142.466 27.6768 142.048 27.2063 141.762C26.7359 141.477 26.1913 141.338 25.6417 141.362C25.092 141.386 24.5619 141.573 24.1184 141.899C23.6749 142.224 23.338 142.674 23.1503 143.192C22.9626 143.709 22.9325 144.27 23.0638 144.804C23.1951 145.339 23.482 145.822 23.8881 146.193C24.2942 146.564 24.8013 146.807 25.3453 146.89C25.7061 146.945 26.0743 146.929 26.4289 146.843C26.7835 146.756 27.1175 146.6 27.4118 146.384C27.7061 146.168 27.9548 145.896 28.1438 145.583C28.3328 145.271 28.4583 144.924 28.5132 144.563Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2155 135.796L12.9197 139.016L9.1036 141.039L7.39942 137.814C7.2663 137.563 7.18396 137.289 7.15713 137.007C7.13029 136.724 7.15948 136.439 7.24302 136.168C7.32656 135.897 7.46282 135.646 7.64395 135.427C7.82509 135.209 8.04755 135.029 8.29856 134.897C8.80491 134.631 9.39597 134.576 9.94256 134.744C10.4891 134.913 10.9468 135.291 11.2155 135.796Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9935 150.741C27.9935 152.82 27.1674 154.815 25.6968 156.285C24.2263 157.756 22.2318 158.582 20.1522 158.582C19.8908 158.582 19.6294 158.582 19.3837 158.551C17.9573 158.409 16.597 157.88 15.4505 157.019C14.3041 156.159 13.4154 155.001 12.8811 153.671C12.3468 152.341 12.1872 150.889 12.4199 149.475C12.6525 148.061 13.2684 146.737 14.2005 145.648C15.1327 144.559 16.3455 143.747 17.7071 143.299C19.0687 142.851 20.5271 142.785 21.9236 143.108C23.3202 143.431 24.6015 144.13 25.6283 145.13C26.6552 146.13 27.3882 147.393 27.7478 148.78C27.91 149.421 27.9925 150.08 27.9935 150.741Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9939 150.747C27.9939 152.827 27.1678 154.821 25.6973 156.292C24.2267 157.762 22.2322 158.588 20.1526 158.588C19.8912 158.588 19.6298 158.588 19.3841 158.557C19.0837 157.397 19.0532 156.183 19.295 155.009C19.5368 153.835 20.0445 152.733 20.779 151.786C21.5135 150.839 22.4553 150.073 23.532 149.546C24.6087 149.02 25.7918 148.748 26.9902 148.75C27.2464 148.75 27.513 148.75 27.7587 148.787C27.9173 149.428 27.9963 150.086 27.9939 150.747Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M67.467 174.324C68.7983 168.634 65.2651 162.942 59.5753 161.611C53.8855 160.279 48.1937 163.813 46.8624 169.502C45.531 175.192 49.0642 180.884 54.754 182.215C60.4438 183.547 66.1356 180.014 67.467 174.324Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1255 176.648C61.7395 175.558 62.9748 172.555 61.8845 169.941C60.7943 167.327 57.7914 166.092 55.1774 167.182C52.5634 168.272 51.3282 171.275 52.4184 173.889C53.5086 176.503 56.5115 177.739 59.1255 176.648Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3498 216.676H102.293L102.968 213.498C103.238 212.228 102.995 210.903 102.292 209.812C101.589 208.721 100.482 207.952 99.2143 207.674C92.5596 206.179 78.1525 205.641 78.1525 205.641C74.6814 205.75 65.0208 206.163 58.3661 207.679C57.107 207.967 56.0117 208.738 55.3171 209.827C54.6225 210.916 54.3845 212.235 54.6546 213.498L55.3498 216.676Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1207 206.414C84.109 205.86 78.1705 205.641 78.1705 205.641C75.9854 205.709 71.3433 205.902 66.5444 206.414C67.9454 211.198 72.692 214.721 78.3326 214.721C83.9731 214.721 88.7198 211.182 90.1207 206.414Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M127.356 194.265L130.276 190.352L104.761 171.312L101.841 175.225L127.356 194.265Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M114.662 205.822L118.575 208.742L130.258 193.085L126.345 190.165L114.662 205.822Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M124.764 188.879C125.116 188.408 125.557 188.01 126.063 187.709C126.569 187.407 127.129 187.209 127.712 187.124C128.294 187.04 128.888 187.071 129.458 187.216C130.029 187.361 130.565 187.617 131.037 187.97L131.377 188.247C131.981 188.798 132.423 189.505 132.654 190.29C132.885 191.075 132.896 191.908 132.686 192.699C132.477 193.49 132.054 194.209 131.465 194.776C130.875 195.344 130.142 195.739 129.343 195.919C128.545 196.098 127.713 196.055 126.937 195.795C126.161 195.535 125.472 195.066 124.943 194.441C124.415 193.816 124.068 193.059 123.941 192.25C123.813 191.442 123.91 190.614 124.22 189.857C124.36 189.51 124.543 189.182 124.764 188.879Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M114.554 201.389C115.216 200.405 116.243 199.724 117.408 199.497C118.572 199.27 119.78 199.514 120.764 200.177C120.884 200.255 120.999 200.344 121.114 200.433C121.745 200.954 122.222 201.638 122.491 202.411C122.761 203.183 122.813 204.015 122.643 204.816C122.472 205.616 122.086 206.354 121.525 206.95C120.964 207.546 120.25 207.977 119.462 208.196C118.673 208.415 117.84 208.413 117.052 208.191C116.264 207.969 115.553 207.535 114.994 206.937C114.436 206.339 114.052 205.599 113.885 204.797C113.718 203.996 113.774 203.165 114.047 202.393C114.173 202.039 114.344 201.702 114.554 201.389Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M101.111 206.988L108.468 207.711L108.746 204.881L101.389 204.158L101.111 206.988Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M100.668 203.346L104.296 203.702L103.873 207.999L100.245 207.643C99.6752 207.588 99.1508 207.308 98.7871 206.866C98.4234 206.424 98.2502 205.855 98.3055 205.286C98.3624 204.715 98.6431 204.191 99.086 203.827C99.529 203.464 100.098 203.291 100.668 203.346Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M107.923 205.175C108.498 204.319 109.236 203.585 110.095 203.014C110.953 202.443 111.916 202.047 112.928 201.849C113.94 201.651 114.981 201.655 115.992 201.859C117.002 202.064 117.963 202.466 118.818 203.042C119.032 203.189 119.236 203.34 119.435 203.502C120.54 204.416 121.373 205.615 121.845 206.969C122.316 208.323 122.407 209.78 122.108 211.182C121.809 212.585 121.132 213.878 120.149 214.922C119.166 215.966 117.916 216.72 116.534 217.103C115.153 217.486 113.692 217.483 112.312 217.094C110.932 216.705 109.685 215.945 108.707 214.897C107.729 213.849 107.057 212.553 106.764 211.149C106.471 209.746 106.568 208.289 107.045 206.937C107.262 206.315 107.557 205.723 107.923 205.175Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4824 213.318L109.206 206.047L110.769 208.133L101.045 215.399L99.4824 213.318Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4684 213.211L101.14 211.188L103.513 214.324L100.842 216.326C100.422 216.64 99.8953 216.775 99.3768 216.7C98.8582 216.626 98.3904 216.348 98.0763 215.929C97.7752 215.514 97.6477 214.998 97.7209 214.49C97.7941 213.983 98.0622 213.524 98.4684 213.211Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M112.046 208.295C112.17 207.758 112.131 207.197 111.935 206.682C111.739 206.167 111.394 205.722 110.945 205.404C110.496 205.085 109.962 204.907 109.411 204.892C108.86 204.877 108.318 205.026 107.852 205.32C107.386 205.614 107.018 206.039 106.794 206.543C106.571 207.046 106.501 207.605 106.596 208.148C106.69 208.69 106.943 209.193 107.324 209.591C107.704 209.99 108.194 210.267 108.732 210.386C109.448 210.546 110.199 210.415 110.82 210.024C111.441 209.632 111.881 209.011 112.046 208.295Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M117.2 220.63L118.643 210.656L120.781 210.959L119.343 220.934L117.2 220.63Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M116.535 221.151L116.927 218.406L120.173 218.871L119.781 221.611C119.751 221.824 119.679 222.03 119.57 222.215C119.46 222.401 119.315 222.564 119.143 222.693C118.97 222.823 118.774 222.917 118.565 222.971C118.356 223.025 118.139 223.037 117.925 223.006C117.495 222.944 117.107 222.714 116.846 222.366C116.586 222.018 116.474 221.581 116.535 221.151Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M121.61 210.31C121.364 209.927 121.01 209.625 120.592 209.442C120.175 209.26 119.712 209.206 119.264 209.286C118.815 209.366 118.401 209.578 118.072 209.894C117.744 210.21 117.516 210.616 117.418 211.061C117.321 211.506 117.357 211.97 117.523 212.394C117.689 212.819 117.977 213.184 118.35 213.445C118.724 213.706 119.166 213.851 119.622 213.86C120.077 213.87 120.526 213.744 120.91 213.499C121.425 213.169 121.788 212.647 121.92 212.05C122.051 211.452 121.94 210.826 121.61 210.31Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M107.578 219.306L114.06 209.039L116.261 210.419L109.784 220.691L107.578 219.306Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M106.59 219.549L108.362 216.727L111.713 218.818L109.936 221.646C109.656 222.088 109.213 222.402 108.702 222.518C108.192 222.635 107.656 222.545 107.212 222.268C106.77 221.989 106.456 221.547 106.34 221.037C106.223 220.528 106.313 219.993 106.59 219.549Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M117.511 210.111C117.434 209.567 117.196 209.058 116.829 208.648C116.462 208.239 115.981 207.948 115.448 207.812C114.915 207.677 114.354 207.702 113.836 207.886C113.318 208.07 112.866 208.403 112.537 208.844C112.209 209.285 112.018 209.814 111.991 210.363C111.963 210.912 112.099 211.457 112.382 211.929C112.664 212.4 113.081 212.778 113.578 213.012C114.075 213.247 114.631 213.329 115.175 213.248C115.9 213.14 116.553 212.75 116.991 212.162C117.429 211.574 117.616 210.837 117.511 210.111Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M105.503 180.996C110.416 177.833 111.836 171.286 108.673 166.373C105.51 161.459 98.9625 160.04 94.049 163.203C89.1355 166.366 87.7164 172.913 90.8793 177.826C94.0422 182.74 100.589 184.159 105.503 180.996Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M104.433 174.24C105.614 171.665 104.484 168.621 101.91 167.44C99.3352 166.26 96.291 167.389 95.1102 169.964C93.9294 172.538 95.0591 175.582 97.6335 176.763C100.208 177.944 103.252 176.814 104.433 174.24Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3161 151.13C87.7021 151.13 95.3109 143.521 95.3109 134.135C95.3109 124.749 87.7021 117.141 78.3161 117.141C68.9301 117.141 61.3213 124.749 61.3213 134.135C61.3213 143.521 68.9301 151.13 78.3161 151.13Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M102.624 145.459C106.274 140.883 108.558 135.37 109.214 129.554C109.87 123.737 108.87 117.854 106.331 112.58C103.792 107.307 99.8155 102.857 94.8596 99.7428C89.9036 96.6286 84.1694 94.9766 78.3162 94.9766C72.4631 94.9766 66.7288 96.6286 61.7729 99.7428C56.8169 102.857 52.8406 107.307 50.3013 112.58C47.762 117.854 46.7627 123.737 47.4184 129.554C48.0742 135.37 50.3583 140.883 54.008 145.459H102.624Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3353 114.336H58.5154C56.1538 114.336 54.2393 116.25 54.2393 118.612V132.371C54.2393 134.733 56.1538 136.647 58.5154 136.647H97.3353C99.6969 136.647 101.611 134.733 101.611 132.371V118.612C101.611 116.25 99.6969 114.336 97.3353 114.336Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3638 124.582C59.8772 123.144 60.8129 121.895 62.0483 120.999C63.2836 120.102 64.7611 119.6 66.2869 119.558C67.8127 119.515 69.3157 119.935 70.599 120.761C71.8822 121.588 72.8858 122.783 73.4782 124.19",
    stroke: "#263238",
    strokeWidth: 4.21652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7773 124.582C83.2907 123.144 84.2264 121.895 85.4618 120.999C86.6972 120.102 88.1746 119.6 89.7004 119.558C91.2262 119.515 92.7293 119.935 94.0125 120.761C95.2958 121.588 96.2994 122.783 96.8918 124.19",
    stroke: "#263238",
    strokeWidth: 4.21652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2212 129.75C74.3524 130.787 74.8573 131.74 75.6412 132.431C76.4251 133.122 77.4341 133.503 78.479 133.503C79.524 133.503 80.533 133.122 81.3169 132.431C82.1008 131.74 82.6057 130.787 82.7369 129.75H74.2212Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M118.56 131.523C117.697 131.523 116.87 131.18 116.26 130.57C115.651 129.96 115.308 129.133 115.308 128.271V120.874C115.307 120.447 115.391 120.023 115.554 119.628C115.717 119.233 115.957 118.874 116.259 118.571C116.561 118.269 116.919 118.029 117.314 117.865C117.709 117.701 118.132 117.617 118.56 117.617C118.987 117.617 119.41 117.7 119.806 117.863C120.201 118.026 120.56 118.266 120.862 118.568C121.165 118.87 121.405 119.228 121.568 119.623C121.732 120.018 121.816 120.441 121.816 120.869V128.266C121.817 128.694 121.733 129.117 121.57 129.513C121.406 129.908 121.167 130.268 120.864 130.57C120.562 130.873 120.202 131.113 119.807 131.276C119.411 131.439 118.988 131.523 118.56 131.523Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2055 131.523C36.7781 131.523 36.3547 131.44 35.9596 131.276C35.5645 131.113 35.2054 130.874 34.9029 130.572C34.6004 130.27 34.3605 129.911 34.1967 129.516C34.033 129.122 33.9487 128.698 33.9487 128.271V120.874C33.948 120.446 34.0318 120.022 34.1952 119.627C34.3587 119.231 34.5985 118.872 34.9011 118.57C35.2036 118.267 35.5629 118.027 35.9584 117.864C36.3538 117.7 36.7776 117.617 37.2055 117.617C37.6325 117.617 38.0553 117.701 38.4498 117.865C38.8443 118.028 39.2028 118.268 39.5047 118.57C39.8066 118.871 40.0461 119.23 40.2095 119.624C40.3729 120.019 40.457 120.442 40.457 120.869V128.266C40.4577 128.693 40.3741 129.117 40.211 129.512C40.0479 129.907 39.8085 130.266 39.5065 130.568C39.2045 130.871 38.8459 131.111 38.451 131.274C38.0562 131.438 37.6329 131.523 37.2055 131.523Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6214 98.1406C44.7452 102.39 43.2118 107.406 43.2198 112.537V117.911",
    stroke: "#263238",
    strokeWidth: 11.8063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M109.356 98.1643C107.003 94.6576 103.822 91.7842 100.095 89.7976C96.3682 87.811 92.2095 86.7724 87.9862 86.7734H68.984C64.7665 86.7705 60.613 87.8045 56.8891 89.7845C53.1653 91.7645 49.9854 94.6296 47.6294 98.1277",
    stroke: "#263238",
    strokeWidth: 5.90313,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M113.728 117.914V112.54C113.736 107.418 112.21 102.411 109.347 98.1641",
    stroke: "#263238",
    strokeWidth: 11.8063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8134 112.125H41.4537C38.9303 112.125 36.8848 114.171 36.8848 116.694V131.796C36.8848 134.32 38.9303 136.365 41.4537 136.365H45.8134C48.3368 136.365 50.3823 134.32 50.3823 131.796V116.694C50.3823 114.171 48.3368 112.125 45.8134 112.125Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3304 112.125H42.9556V136.365H44.3304V112.125Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M114.68 112.125H110.32C107.797 112.125 105.751 114.171 105.751 116.694V131.796C105.751 134.32 107.797 136.365 110.32 136.365H114.68C117.203 136.365 119.249 134.32 119.249 131.796V116.694C119.249 114.171 117.203 112.125 114.68 112.125Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M113.186 112.125H111.811V136.365H113.186V112.125Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4301 109.927C80.8114 109.928 83.155 109.332 85.247 108.194C87.339 107.057 89.1127 105.413 90.4064 103.414L93.3548 98.8501C88.6828 96.27 83.4251 94.9363 78.0882 94.9775C72.7513 95.0187 67.5149 96.4334 62.8833 99.0853L67.3215 104.595C68.6566 106.258 70.3477 107.6 72.2702 108.523C74.1926 109.446 76.2976 109.926 78.4301 109.927Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M79.171 138.906C79.171 138.802 79.1403 138.701 79.0829 138.615C79.0255 138.529 78.9438 138.462 78.8483 138.423C78.7528 138.383 78.6477 138.373 78.5463 138.393C78.4449 138.413 78.3517 138.463 78.2786 138.536C78.2055 138.609 78.1557 138.702 78.1355 138.804C78.1154 138.905 78.1257 139.01 78.1653 139.106C78.2048 139.201 78.2719 139.283 78.3578 139.34C78.4438 139.398 78.5449 139.428 78.6482 139.428C78.7869 139.428 78.9199 139.373 79.0179 139.275C79.1159 139.177 79.171 139.044 79.171 138.906Z",
    fill: "#263238"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M79.171 140.656C79.171 140.552 79.1403 140.451 79.0829 140.365C79.0255 140.279 78.9438 140.212 78.8483 140.173C78.7528 140.133 78.6477 140.123 78.5463 140.143C78.4449 140.163 78.3517 140.213 78.2786 140.286C78.2055 140.359 78.1557 140.452 78.1355 140.554C78.1154 140.655 78.1257 140.76 78.1653 140.856C78.2048 140.951 78.2719 141.033 78.3578 141.09C78.4438 141.148 78.5449 141.178 78.6482 141.178C78.7869 141.178 78.9199 141.123 79.0179 141.025C79.1159 140.927 79.171 140.794 79.171 140.656Z",
    fill: "#263238"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1829 140.384C77.2783 140.322 77.3511 140.231 77.3902 140.124C77.4293 140.018 77.4325 139.901 77.3995 139.792C77.3664 139.684 77.2988 139.589 77.2068 139.522C77.1149 139.455 77.0037 139.42 76.8901 139.422C76.7946 139.484 76.7218 139.575 76.6828 139.681C76.6437 139.788 76.6404 139.905 76.6735 140.013C76.7066 140.122 76.7742 140.217 76.8661 140.284C76.958 140.351 77.0692 140.386 77.1829 140.384Z",
    fill: "#263238"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3175 140.389C80.3984 140.388 80.4778 140.368 80.5496 140.33C80.6213 140.293 80.6834 140.239 80.731 140.174C80.7786 140.109 80.8104 140.033 80.8238 139.953C80.8372 139.873 80.8319 139.792 80.8084 139.714C80.7848 139.637 80.7436 139.566 80.6881 139.507C80.6325 139.449 80.564 139.403 80.4881 139.376C80.4121 139.348 80.3307 139.338 80.2503 139.347C80.1699 139.356 80.0927 139.383 80.0248 139.427C79.9439 139.429 79.8644 139.449 79.7927 139.486C79.7209 139.524 79.6588 139.577 79.6112 139.642C79.5637 139.708 79.5319 139.783 79.5185 139.863C79.5051 139.943 79.5103 140.025 79.5339 140.102C79.5574 140.18 79.5986 140.25 79.6542 140.309C79.7098 140.368 79.7783 140.413 79.8542 140.441C79.9302 140.469 80.0115 140.478 80.0919 140.47C80.1723 140.461 80.2495 140.433 80.3175 140.389Z",
    fill: "#263238"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2153 158.515C92.5606 157.015 78.1534 156.477 78.1534 156.477C74.6823 156.586 65.0218 156.999 58.3671 158.521C57.1073 158.807 56.0111 159.578 55.3162 160.667C54.6214 161.757 54.384 163.076 54.6555 164.339L60.8188 193.174C61.1216 194.572 61.8932 195.825 63.0056 196.724C64.1181 197.624 65.5045 198.116 66.9351 198.119H90.6943C92.1249 198.116 93.5113 197.624 94.6238 196.724C95.7362 195.825 96.5078 194.572 96.8106 193.174L102.969 164.339C103.239 163.069 102.996 161.744 102.293 160.653C101.59 159.562 100.483 158.793 99.2153 158.515Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1786 157.961C88.9593 156.884 78.1644 156.477 78.1644 156.477C72.8788 156.628 67.6053 157.064 62.3667 157.783L69.3507 198.119H88.332L96.1786 157.961Z",
    fill: "#FF725E",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3971 165.242H72.8338C70.4721 165.242 68.5576 167.157 68.5576 169.518V175.164C68.5576 177.526 70.4721 179.44 72.8338 179.44H84.3971C86.7588 179.44 88.6733 177.526 88.6733 175.164V169.518C88.6733 167.157 86.7588 165.242 84.3971 165.242Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M75.2338 171.094H71.9771V174.351H75.2338V171.094Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2382 171.094H76.9814V174.351H80.2382V171.094Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2543 171.094H81.9976V174.351H85.2543V171.094Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8579 189.008H90.8002C91.4934 189.008 92.1582 189.283 92.6484 189.773C93.1386 190.264 93.414 190.928 93.414 191.622V224.174H30.2441V191.622C30.2441 190.928 30.5195 190.264 31.0097 189.773C31.4999 189.283 32.1647 189.008 32.8579 189.008Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M93.414 200.703C85.4785 202.716 77.334 207.839 62.1584 215.053C47.5212 222.016 35.5397 221.896 30.2441 221.357V224.17H93.414V200.703Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M93.414 222.227H30.2441V224.182H93.414V222.227Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M65.0765 206.593C65.0765 207.237 64.8855 207.866 64.5277 208.402C64.1698 208.938 63.6612 209.355 63.0661 209.602C62.471 209.848 61.8161 209.913 61.1844 209.787C60.5526 209.661 59.9723 209.351 59.5169 208.896C59.0614 208.44 58.7512 207.86 58.6256 207.228C58.4999 206.596 58.5644 205.941 58.8109 205.346C59.0574 204.751 59.4748 204.243 60.0104 203.885C60.546 203.527 61.1756 203.336 61.8198 203.336C62.6835 203.336 63.5119 203.679 64.1226 204.29C64.7334 204.901 65.0765 205.729 65.0765 206.593Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 0.843304,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBro);
export default __webpack_public_path__ + "static/media/bro.074d4b186625a56c8d1f57bfefd48426.svg";
export { ForwardRef as ReactComponent };